import React from 'react'
import { Tooltip, Stack } from '@mui/material'
import { ImageIcon } from '@/icon'
import assistantCode from '@/asset/img/assistant_code.webp'
import Text from '@/components/Text'

const AssistantCode = ({
  children,
  show,
}: {
  children: React.ReactElement;
  show?: boolean;
}) => {
  return (
    <Tooltip
      open={show}
      placement="top"
      arrow
      slotProps={{
        tooltip: {
          sx: {
            backgroundColor: '#fff',
            boxShadow: '0 4px 14px 0 #1a041b0f',
          },
        },
        arrow: {
          sx: { color: '#fff' },
        },
      }}
      title={
        <Stack
          sx={{
            alignItems: 'center',
          }}
        >
          <ImageIcon src={assistantCode} sx={{ width: '160px' }} />
          <Text size="xs" sx={{ margin: '8px' }}>
            请微信联系百川万能小助手
          </Text>
        </Stack>
      }
    >
      {children}
    </Tooltip>
  )
}

export default AssistantCode
